module.exports = __webpack_public_path__ + "static/media/AWI Logo.c1bed777.jpg";